import type { AppDispatch, RootState } from "~/store";

import { skipTour, startTour, type WalkthroughStatus } from "~/store/walkthroughSlice";

interface WalkthroughE2ESnapshot {
	activeTourId: string | null;
	status: WalkthroughStatus;
	stepIndex: number;
}

interface WalkthroughE2EHandle {
	getState: () => WalkthroughE2ESnapshot;
	skip: () => void;
	start: (tourId: string) => void;
}

interface WalkthroughE2EStore {
	dispatch: AppDispatch;
	getState: () => RootState;
}

declare global {
	interface Window {
		__walkthroughE2E?: WalkthroughE2EHandle;
	}
}

const installWalkthroughE2E = (store: WalkthroughE2EStore): void => {
	window.__walkthroughE2E = {
		getState: () => {
			const { activeTourId, status, stepIndex } = store.getState().walkthrough;
			return { activeTourId, status, stepIndex };
		},
		skip: () => {
			store.dispatch(skipTour());
		},
		start: (tourId: string) => {
			store.dispatch(startTour({ tourId }));
		}
	};
};

export default installWalkthroughE2E;
